/* import { nz } from '@siptel-web/common'; */
import { matchPath } from 'react-router-dom';

// ----------------------------------------------------------------------

export { default as NavSectionVertical } from './vertical';
export { default as NavSectionHorizontal } from './horizontal';

export function isExternalLink(path) {
  return path.includes('http');
}

export function getActive(path, pathname) {
  return path ? !!matchPath({ path, end: false }, pathname) : false;
}

function recursiveChildren(items, user) {
  const filtered = items
    .filter((item) => {
      const newItem = { ...item };

      if (
        typeof newItem.shouldRender === 'function' &&
        !newItem.shouldRender(user)
      ) {
        return null;
      }

      if (Array.isArray(item.items)) {
        const newChildren = recursiveChildren(item.items, user);

        newItem.items = newChildren;
      }

      if (Array.isArray(newItem.items) && (newItem.items ?? []).length === 0) {
        return null;
      }

      if (Array.isArray(item.children)) {
        const newChildren = recursiveChildren(item.children, user);

        newItem.children = newChildren;
      }

      if (
        Array.isArray(newItem.children) &&
        (newItem.children ?? []).length === 0
      ) {
        return null;
      }

      return newItem;
    })
    .filter((exists) => exists);

  return filtered;
}

export const FilterNavItemsFunction = (navConfig, user) => {
  return recursiveChildren(navConfig, user);
};
export const FilterNavItemsFunction2 = (navConfig, user) => {
  let aux = navConfig.map((element) => element);

  let newArrFilter = [];
  aux.forEach((item) => {
    const newItem = item;
    const arrItems = item.items.filter((section) => {
      //telefonia
      section.children = section.children.filter((child) => {
        //esta instancia siempre existe, pero no siempre exiten esta "instancia.children"
        //reportes
        if (child.children) {
          child.children = child.children.filter((child) =>
            //llamadas
            child.shouldRender(user),
          );
        }
        if (child.children) {
          // Para filtrar por permisos(shouldRender) y si tiene "heredero", si es un array vacio no tiene hijos Y NO deberia mostrarse
          return child.shouldRender(user) && child.children.length > 0;
        }
        return child.shouldRender(user);
      });
      return section.shouldRender(user);
    });
    newItem.items = arrItems.length === 0 ? [] : arrItems;
    newArrFilter.push(newItem);
  });
  newArrFilter = newArrFilter.filter((item) => {
    return item.items.length;
  });

  return newArrFilter;
};

/* import { nz } from '@siptel-web/common';
import { matchPath } from 'react-router-dom';

// ----------------------------------------------------------------------

export { default as NavSectionVertical } from './vertical';
export { default as NavSectionHorizontal } from './horizontal';

export function isExternalLink(path) {
  return path.includes('http');
}

export function getActive(path, pathname) {
  return path ? !!matchPath({ path, end: false }, pathname) : false;
}

export function getFilteredNavMenu2(navConfig, user) {
  return (navConfig ?? [])
    .map((group) => {
      // |  Telefonia (group) <-- we are here
      // |-------------
      // |    Reportes (group.item)
      // |    - Llamadas Contestadas (group.item.child)

      // if (
        //typeof group.shouldRender === 'function' &&
       // !group.shouldRender(user)
      // ) {
       // return null;
     // } 

      const items = group.items
        .map((item) => {
          // |  cada modulo
          // |-------------
          //      Telefonia (group)<-- we are here
          // |    Reportes (group.item)
          // |    - Llamadas Contestadas (group.item.child)

          if (
            typeof item.shouldRender === 'function' &&
            !item.shouldRender(user)
          ) {
            return null;
          }
          const children2 = (item.children ?? [])
            .map((child) => {
              const secondChildren = child.children
                ?.map((secondChild) => {
                  if (
                    typeof child.shouldRender === 'function' &&
                    child.shouldRender(user)
                  ) {
                    return child;
                  } else {
                    return null;
                  }
                })
                .filter((exists) => exists);
              if (
                typeof child.shouldRender === 'function' &&
                child.shouldRender(user)
              ) {
                return child;
              } else {
                return null;
              }
            })
            .filter((exists) => exists);
          const children = (item.children ?? []).filter((child) => {
            // |  Telefonia (group)
            // |-------------
            // |    Reportes (group.item)<-- we are here
            // |    - Llamadas Contestadas (group.item.child)

            // returns the result of the shouldRender function if exists, otherwise returs false to not render the item by default
            const secondChildren = child.children?.filter((secondChild) => {
              secondChild);
              return typeof secondChild.shouldRender === 'function'
                ? secondChild.shouldRender(user)
                : false;
            });
            const hasFilteredItems =
              nz((item.children ?? []).length) !== children.length;
            console.log(secondChildren);
            return typeof child.shouldRender === 'function'
              ? child.shouldRender(user)
              : false;
          });
          console.log(item.children);
          const hasFilteredItems =
            nz((item.children ?? []).length) !== children.length;

          // do not render the menu item if there are no children to render
          return hasFilteredItems && children.length === 0
            ? null
            : { ...item, children };
        })
        .filter((exists) => exists);

      const hasFilteredItems = nz((group.items ?? []).length) !== items.length;

      // do not render the menu group if there are not items to render
      return hasFilteredItems && items.length === 0
        ? null
        : { ...group, items };
    })
    .filter((exists) => exists);
}

function recursive(items, user) {
  const filtered = items
    .filter((item) => {
      console.log(item.shouldRender(user));
      if (typeof item.shouldRender === 'function' && !item.shouldRender(user)) {
        return null;
      }

      const newItem = JSON.parse(JSON.stringify(item));

      if (Array.isArray(item.children)) {
        const newChildren = recursive(item.children, user);

        newItem.children = newChildren;
      }

      return newItem;
    })
    .filter((exists) => exists);
  console.log(filtered);

  

  return filtered;
}
const getNavMenu = (items, user) => {
  const filtered = items
    .map((group) => {
      const items = group.items.map((item) => {
        // |  cada modulo
        // |-------------
        //      Telefonia (group)<-- we are here
        // |    Reportes (group.item)
        // |    - Llamadas Contestadas (group.item.child)

        if (
          typeof item.shouldRender === 'function' &&
          !item.shouldRender(user)
        ) {
          return null;
        }
        const children = (item.children ?? []).map((child) => {
          const secondChildren = child.children?.map((secondChild) => {
            if (
              typeof child.shouldRender === 'function' &&
              child.shouldRender(user)
            ) {
              return child;
            } else {
              return null;
            }
          });

          if (
            typeof child.shouldRender === 'function' &&
            child.shouldRender(user)
          ) {
            return child;
          } else {
            return null;
          }
        });
      });
    })
    .filter((exists) => exists);
  console.log(filtered);
};

export function getFilteredNavMenu(navConfig, user) {
  return getNavMenu(navConfig, user);
} */

/* export const FilterNavItemsFunction = (navConfig, user) => {
  console.log(navConfig);
  let aux = navConfig.map((element) => element);

  console.log(aux);
  let newArrFilter = [];
  aux.forEach((item) => {
    const newItem = item;
    const arrItems = item.items.filter((section) => {
      //telefonia
      section.children = section.children.filter((child) => {
        //esta instancia siempre existe, pero no siempre exiten esta "instancia.children"
        //reportes
        if (child.children) {
          child.children = child.children.filter((child) =>
            //llamadas
            child.shouldRender(user),
          );
        }
        if (child.children) {
          // Para filtrar por permisos(shouldRender) y si tiene "heredero", si es un array vacio no tiene hijos Y NO deberia mostrarse
          return child.shouldRender(user) && child.children.length > 0;
        }
        return child.shouldRender(user);
      });
      return section.shouldRender(user);
    });
    newItem.items = arrItems.length === 0 ? [] : arrItems;
    newArrFilter.push(newItem);
  });
  newArrFilter = newArrFilter.filter((item) => {
    
    return item.items.length;
  });

  return newArrFilter;
}; */
